import { Helmet } from "react-helmet-async";

const SITE_URL = "https://kmc-health.com";

export default function SEO({ title, description, path }) {
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
